export class TimeZoneOffsetModel {
    public static TimeZoneOffsetList: Array<any> = [
        { name: 'Philippines', value: 8 }
    ];
}
